import React, { Fragment } from "react";
import { Form, Input, Button, Select } from "antd";
import { ReactSVG } from "react-svg";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSpinGames } from "../../actions/spinTheWheelGame";

const SpinGameMessageForm = ({
	handleSubmitForm,
	form,
	handleCancel,
	spinGameMessageId,
}) => {
	const dispatch = useDispatch();
	const { spinGames, loading } = useSelector((state) => state.fetchSpinGames);
	useEffect(() => {
		dispatch(fetchSpinGames());
	}, []);
	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Game"
						name="game_id"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select
							placeholder="Required"
							showSearch
							optionFilterProp="children"
							loading={loading}
						>
							{spinGames &&
								spinGames.data.data.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Content"
						name="content"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input.TextArea placeholder="Required" rows={5} />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{spinGameMessageId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default SpinGameMessageForm;
